import { CONDITION_MAP } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StatusBadge({ condition, className }) {
  const c = CONDITION_MAP[condition];
  if (!c) return null;
  return (
    <span
      data-testid={`status-badge-${condition}`}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider",
        c.badge,
        className
      )}
    >
      {c.label}
    </span>
  );
}
